export interface DetailShopInfo {
    commodityCount: number;
    imgUrl: string;
    merchantId: number;
    shopId: number;
    shopName: string;
    smallImgUrl: string;
    userStatus: number;
}

export enum COUPON_RANGE_TYPE {
    AllItem, // 所有商品
    Item, // 指定商品
    Shop, // 指定店铺
    Category, // 指定品类
}
